<template>
    <div class="container">
        <div class="container-main">
            <div class="card">
                <div class="info">
                    <div class="avatar">
                        <img :src="avatar"
                             alt="">
                    </div>
                    <div class="desc">
                        <p class="desc-title">{{ merchantName }}</p>
                        <p class="desc-text">{{ $t('phoneLabel') }}{{ contactPhone }}</p>
                        <p class="desc-text">{{ $t('addressLabel') }}{{ address }}</p>
                    </div>
                </div>
                <p class="describe">{{description}}</p>
            </div>
        </div>
        <div class="container-handle">
            <p class="agreement">
                <a href="javascript:void(0);"
                   class="text"
                   @click="checked = !checked">
                    <img src="../assets/images/checked.png"
                         alt=""
                         v-if="checked">
                    <img src="../assets/images/unchecked.png"
                         alt=""
                         v-else>
                    <span>{{ $t('readAndAccept') }}</span>
                </a>
                <a href="javascript:void(0);"
                   class="privacy">{{ $t('privacyPolicy') }}</a>
            </p>
            <div class="handle">
                <a class="btn usable"
                   href="javascript:void(0);"
                   @click="startLotteryHandle"
                   v-if="checked">{{ $t('startLottery') }}</a>
                <a class="btn disable"
                   href="javascript:void(0);"
                   v-else>{{ $t('startLottery') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
// /lottery?merchantId=201800800000097&code=166775810270298145
// /lottery?merchantId=201800800000097&code=167233210328678404   生产
// https://laidan.it/m/lottery?merchantId=201800800000097&code=167490863269281824
// http://boss.laidan.ngrok.saonian.org/laidan-ad/#/lottery?merchantId=201800800000000&code=166775810270298145
import userImg from "@/assets/images/user.png"
import { queryLotteryMerchant } from "@/api";
import { mapMutations, mapState } from "vuex";
export default {
    name: 'Lottery',
    // 组件
    components: {
    
    },
    props: {},
    data () {
        return {
            avatar: userImg,
            merchantName: '',
            contactPhone: '',
            address: '',
            description: '',
            checked: false,
        };
    },
    // 计算属性
    computed: {
        ...mapState(['pointsMeMerId', 'lotteryCode']),
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        ...mapMutations(['saveLotteryInfo', 'saveLoginBeforeRouter']),
        // 初始化数据
        initData () {
            const token = localStorage.getItem('laidanToken')
            const merchantId = this.$route.query.merchantId
            const code = this.$route.query.code || ''
            if (merchantId) {
                this.saveLotteryInfo({
                    merchantId: merchantId,
                    code: code
                })
                if (token) {
                    if (code) {
                        this.getMerchantInfo(merchantId)
                    } else {
                        this.$router.replace({ path: '/my-lottery' })
                    }
                } else {
                    this.saveLoginBeforeRouter('Lottery')
                    this.$router.replace({ path: '/login' })
                }
            } else if (this.pointsMeMerId) {
                if (token) {
                    if (this.lotteryCode) {
                        this.getMerchantInfo(this.pointsMeMerId)
                    } else {
                        this.$router.replace({ path: '/my-lottery' })
                    }
                } else {
                    this.saveLoginBeforeRouter('Lottery')
                    this.$router.replace({ path: '/login' })
                }
            } else {
                this.$router.replace({ path: '/404' })
            }
        },
        // 获取商家信息
        getMerchantInfo (id) {
            let params = {
                mid: id
            }
            queryLotteryMerchant(params).then(res => {
                if (Number(res.code) === 20000) {
                    const list = res.data.list
                    if (list instanceof Array && list.length > 0) {
                        if (list[0].logoUrl) {
                            this.avatar = list[0].logoUrl
                        }
                        this.merchantName = list[0].name
                        if (list[0].address) {
                            this.contactPhone = list[0].address.contactPhone
                            this.address = list[0].address.address
                        }
                        this.description = list[0].description
                    }
                } else {
                    this.$toast.fail(res.msg);
                }
            }).catch(err => {
                this.$toast.fail(err);
            })
        },
        // 开始抽奖
        startLotteryHandle () {
            this.$router.push({ path: '/winning' })
        },
    },
    // 创建完成
    created () {
        // 初始化数据
        this.initData()
    },
    // 挂载完成
    mounted () {

    },
    // 销毁之前
    beforeDestroy () {

    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    background-color: #fafafa;
    display: flex;
    flex-direction: column;
    .container-main {
        width: 100%;
        flex-grow: 1;
        padding-top: 32px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        overflow-y: auto;
        .card {
            width: 300px;
            padding: 32px 28px;
            background-color: #f8dfd2;
            border-radius: 20px;
            overflow-y: auto;
            .info {
                width: 100%;
                display: flex;
                padding-bottom: 20px;
                border-bottom: 1px dashed rgba(60, 60, 67, 0.4);
                .avatar {
                    width: 64px;
                    height: 64px;
                    flex-shrink: 0;
                    border-radius: 50%;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .desc {
                    padding-left: 32px;
                    .desc-title {
                        font-size: 15px;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #3c3c43;
                        line-height: 21px;
                    }
                    .desc-text {
                        font-size: 12px;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: rgba(60, 60, 67, 0.4);
                        line-height: 21px;
                    }
                }
            }
            .describe {
                padding-top: 20px;
                font-size: 12px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: rgba(60, 60, 67, 0.4);
                line-height: 21px;
            }
        }
    }
    .container-handle {
        flex-shrink: 0;
        padding: 24px 32px;
        .agreement {
            width: 100%;
            padding-left: 24px;
            padding-right: 24px;
            margin-top: 8px;
            .text {
                img {
                    width: 12px;
                    height: 12px;
                    object-fit: contain;
                }
                span {
                    margin-left: 6px;
                    font-size: 12px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    color: #3c3c43;
                }
            }
            .privacy {
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                margin-left: 4px;
                color: #ee8d35;
                text-decoration: underline;
            }
            &:first-of-type {
                margin-top: 0;
            }
        }
        .handle {
            margin-top: 24px;
            width: 100%;
            display: flex;
            justify-content: center;
            .btn {
                width: 200px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 13px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #ffffff;
                background: linear-gradient(90deg, #ec5e29 0%, #ee8d35 100%);
                border-radius: 20px;
                &.usable {
                    //background-image: url("../assets/images/btn_bg.png");
                    //background-size: 100% 100%;
                }
                &.disable {
                    //background-image: url("../assets/images/btn_disabled_bg.png");
                    //background-size: 100% 100%;
                    opacity: 0.2;
                }
            }
        }
    }
}
</style>

